interface StreakData {
    currentStreak: number;
    lastCompletionDate: string;
}

const STREAK_KEY = "numbers_streak";

// Get the current streak data
export function getStreakData(): StreakData {
    const stored = localStorage.getItem(STREAK_KEY);
    if (!stored) {
        return { currentStreak: 0, lastCompletionDate: "" };
    }
    return JSON.parse(stored);
}

// Format date as YYYY-MM-DD
function formatDate(date: Date): string {
    return date.toISOString().split("T")[0];
}

// Check if two dates are consecutive days
function areConsecutiveDays(date1: string, date2: string): boolean {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    const diffTime = Math.abs(d2.getTime() - d1.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays === 1;
}

// Update streak when all three difficulties are completed
export function updateStreak(completionDate: string): {
    newStreak: number;
    isNewStreak: boolean;
    previousStreak: number;
} {
    const streakData = getStreakData();
    const today = formatDate(new Date());

    // If completion date is not today, don't update
    if (completionDate !== today) {
        return {
            newStreak: streakData.currentStreak,
            isNewStreak: false,
            previousStreak: streakData.currentStreak,
        };
    }

    // If already completed today, return current streak
    if (streakData.lastCompletionDate === today) {
        return {
            newStreak: streakData.currentStreak,
            isNewStreak: false,
            previousStreak: streakData.currentStreak,
        };
    }

    const previousStreak = streakData.currentStreak;
    let newStreak: number;

    if (!streakData.lastCompletionDate) {
        // First time completing
        newStreak = 1;
    } else if (areConsecutiveDays(streakData.lastCompletionDate, today)) {
        // Consecutive day - increment streak
        newStreak = streakData.currentStreak + 1;
    } else {
        // Missed days - reset to 1
        newStreak = 1;
    }

    const newData: StreakData = {
        currentStreak: newStreak,
        lastCompletionDate: today,
    };

    localStorage.setItem(STREAK_KEY, JSON.stringify(newData));

    return {
        newStreak,
        isNewStreak: true,
        previousStreak,
    };
}

// Check if streak should be reset due to missed days
export function checkAndResetStreak(): void {
    const streakData = getStreakData();
    const today = formatDate(new Date());

    if (!streakData.lastCompletionDate) {
        return;
    }

    // If last completion was today or yesterday, keep streak
    if (
        streakData.lastCompletionDate === today ||
        areConsecutiveDays(streakData.lastCompletionDate, today)
    ) {
        return;
    }

    // Missed days - reset streak
    const newData: StreakData = {
        currentStreak: 0,
        lastCompletionDate: streakData.lastCompletionDate,
    };

    localStorage.setItem(STREAK_KEY, JSON.stringify(newData));
}
